// extracted by mini-css-extract-plugin
export default {"container":"style_container__I8npM","img":"style_img__2fZXs"};